@if (startOptions$ | async; as startOptions) {
	<stages-dialog2 #dialog>
		<stages-dialog-header />
		<div class="content">
			<stages-files-start
				[startOptions]="startOptions"
				headline="files.start.title"
				translateNone="none"
			></stages-files-start>
		</div>
	</stages-dialog2>
}
